export interface AttendancePolicySetting {
  AttendancePolicyId: string;
  LessonTeacherCanFinalize: boolean;
  AuthorizedUserCanFinalize: boolean;
  ToleranceMinutes: number;
  FinalizeMinMinutesAfterEnd: number;
  PropagatePresenceWithinShift: boolean;
  JustificationDeadlineBusinessDays: number;
  JustificationDeadlineAt: string;
  AttachmentMaxCount: number;
  AttachmentMaxSizeMb: number;
  NotifyGuardiansOnFinalize: boolean;
  AutoFinalizeEnabled: boolean;
  AutoFinalizeAfterDays: number;
  AutoFinalizeNotifyGuardians: boolean;
  AttendanceByClassOnly: boolean;
  ComplementDeadlineBusinessDays: number;
  UpdatedOnUtc: string | null;
  UpdatedBy: string | null;
}

export type AttendancePolicySettingRequest = Omit<
  AttendancePolicySetting,
  'UpdatedOnUtc' | 'UpdatedBy'
>;

export const ATTENDANCE_POLICY_LIMITS = {
  ToleranceMinutes: { min: 0, max: 240 },
  FinalizeMinMinutesAfterEnd: { min: 0, max: 240 },
  AutoFinalizeAfterDays: { min: 0, max: 30 },
  JustificationDeadlineBusinessDays: { min: 0, max: 60 },
  ComplementDeadlineBusinessDays: { min: 1, max: 60 },
  AttachmentMaxCount: { min: 0, max: 20 },
  AttachmentMaxSizeMb: { min: 1, max: 100 },
} as const;

export interface AttendancePolicySettingState {
  policy: AttendancePolicySetting | null;
}

export const initialAttendancePolicySettingState: AttendancePolicySettingState = {
  policy: null,
};
